<template>
    <div class="flex justify-center w-full">
        <div class="flex flex-col w-4/5 mt-4">
            <span>Archive Data Before ({{ timezone }})</span>
            <div>
                <date-time-picker   v-model="date"
                                    :timezone="timezone"
                                    :side-by-side="true"
                                    format="MM/DD/YYYY HH:mm:ss"
                ></date-time-picker>
            </div>

            <!-- Archive and Remove Current Data Button -->
            <div    class="mt-2 mb-1">
                <button-blue-secondary      @click="archiveData">
                    Archive and Remove Data Before Date
                </button-blue-secondary>
            </div>

            <div>
                <banner-success     v-model:is-open="successfulArchivingData">
                    <template   #content>
                        <span>Successfully archived data before {{ date }}</span>
                    </template>
                </banner-success>
            </div>

            <!--  -->
            <div>
                <banner-error       v-model:is-open="errorArchivingData">
                    <template   #content>
                        <div>There was an error archiving data before {{ date }}. Please try again.</div>
                        <div>Contact support if you continue to have issues.</div>
                    </template>
                </banner-error>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import DateTimePicker from "@/components/Reports/VueDatePicker.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary.vue";
import ButtonRedPrimary from "@/components/elements/buttons/ButtonRedPrimary.vue";
import BannerSuccess from "@/components/Banners/BannerSuccess.vue";
import BannerError from "@/components/Banners/BannerError.vue";

export default {
    name: "DeviceSettingsArchiveBefore",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {BannerError, BannerSuccess, ButtonRedPrimary, ButtonBlueSecondary, DateTimePicker},
    emits: [],
    props: {
        // Props
        timezone: {
            type: String,
            default: 'America/New_York',
        },
        // Device to archive data from
        deviceId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            // State properties
            archivingData: false,
            successfulArchivingData: false,
            errorArchivingData: false,

            // Data Properties
            date: null,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        // Methods
        archiveData() {
            if (!confirm('Are you sure you want to archive and remove data before this date? This action cannot be undone.')) {
                return
            }

            this.errorArchivingData = false
            this.successfulArchivingData = false
            this.archivingData = true
            axios.patch(this.company.buildCompanyApiInternalRoute(`device-settings/${this.deviceId}`), {
                date: this.date,
            }).then(response => {
                this.successfulArchivingData = true
                setTimeout(() => {
                    // Clear and reset state
                    this.archivingData = false
                    this.errorArchivingData = false
                    this.successfulArchivingData = false

                    // Close the panel
                    this.$emit('update:deviceId', null)
                }, 5000)

            }).catch(error => {
                this.errorArchivingData = true
            }).then(() => {
                this.archivingData = false
            })
        },
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>